const ALPHA_REGEX = /([a-zA-Z])/g;
const ENTITIES_REGEX = /[&<>"']/g;
const ESCAPE_REGEX = /[.*+?^${}()|[\]\\]/g;
// const HIGHLIGHT_REGEX = new RegExp(`<mark>*.</mark>`, 'gi');
const KEYS_REGEX = /\{(\w+)\}/g;
const EMAILS_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

export const camelToCapital = (text) => {
  const result = text.replace(ALPHA_REGEX, ' $1');

  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const capitalize = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : '');

const entities = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
};

export const convertHTMLEntities = (str) => {
  return str.replace(ENTITIES_REGEX, (match) => entities[match] || match);
};

export const truncate = (str, chars, suffix = '') => {
  const TRUNCATE_REGEX = new RegExp(`(.{${chars}})..+`);
  return str.replace(TRUNCATE_REGEX, `$1...${suffix}`);
};

export const escapeRegExp = (text = '') => text.replace(ESCAPE_REGEX, '\\$&');

const highlightCache = {};

export const highlight = (term, text) => {
  if (!term) {
    return text;
  }

  const escapedTerm = escapeRegExp(term);

  let regexp = highlightCache[term];

  if (!regexp) {
    regexp = highlightCache[term] = new RegExp(`(${escapedTerm})`, 'gi');
  }

  return text.replace(regexp, `<mark>$1</mark>`);
};

export const formatTemplate = (template, values) => {
  return !values ? template : template.replace(KEYS_REGEX, (match, key) => values[key]);
};

export const extractEmails = (str) => {
  if (!str) {
    return [];
  }

  let matches;
  let emails = new Set();

  while ((matches = EMAILS_REGEX.exec(str)) !== null) {
    emails.add(matches[1].toLowerCase());
  }

  return Array.from(emails);
};

// Prefixed with a letter so the result is always a valid CSS id selector.
// Many callers use the value as a DOM id queried via `querySelector(`#${id}`)`
// (e.g. sveltestrap tooltips); an id beginning with a digit is an invalid
// selector and silently breaks those lookups.
export const generateUUID = () => `u${Math.random().toString(36).substring(2)}`;

export const formatPEMCertificate = (certString) => {
  if (!certString || certString.length < 10) {
    return certString;
  }

  const cleaned = certString.trim().replace(/\r?\n|\r/g, '');

  const base64Content = cleaned
    .replace(/-*\s*BEGIN\s+CERTIFICATE\s*-*/g, '')
    .replace(/-*\s*END\s+CERTIFICATE\s*-*/g, '')
    .replace(/[^A-Za-z0-9+/=]/g, '');

  const formatted = base64Content.match(/.{1,64}/g)?.join('\n') || base64Content;

  return `-----BEGIN CERTIFICATE-----\n${formatted}\n-----END CERTIFICATE-----`;
};
